import WorkerApiService from "../../workerApiServices"

class NFService extends WorkerApiService {

    constructor() {
        super('/api/NFs')
    }

    commomSearch(
        filtro,
        pageIndex,
        pageSize,
        sortField,
        sortDirection
    ){
        let params = `?`
        params = `${params}&page=${pageIndex}`
        params = `${params}&size=${pageSize}`
        params = `${params}&sort=${sortField},${sortDirection}`
        return this.post(`/commomSearch${params}`, filtro)
    }

    searchByNumero(numero){
        let params = `?`
        params = `${params}&numero=${numero}`
        return this.get(`/searchByNumero${params}`)
    }

    searchNFsAValidar(preValidacao){
        let params = `?`
        params = `${params}&preValidacao=${preValidacao}`
        return this.get(`/searchNFsAValidar${params}`)
    }

    preValidateNF(NFToValidate){
        return this.post(`/preValidateNF`, NFToValidate)
    }

    validateNF(NFToValidate){
        return this.post(`/validateNF`, NFToValidate)
    }

    buscaFormaDePagamentoSalva(nfId){
        let params = `?`
        params = `${params}&nfId=${nfId}`
        return this.get(`/buscaFormaDePagamentoSalva${params}`)
    }

    verificaIntegracaoPedidosCompra(){
        return this.get(`/verificaIntegracaoPedidosCompra`)
    }

    buscaPossiveisPedidosCompraLinkadosNF(nfId){
        let params = `?`
        params = `${params}&id=${nfId}`
        return this.get(`/buscaPossiveisPedidosCompraLinkadosNF${params}`)
    }

    buscaPossiveisPedidosCompraLinkadosNFList(nfIdList){
        return this.post(`/buscaPossiveisPedidosCompraLinkadosNFList`, nfIdList)
    }
    
    buscaPedidosCompraLinkadosNF(nfId){
        let params = `?`
        params = `${params}&id=${nfId}`
        return this.get(`/buscaPedidosCompraLinkadosNF${params}`)
    }


    deleteNF(NFToDelete, gravarFrase){
        let params = `?`
        params = `${params}&gravarFrase=${gravarFrase}`
        return this.post(`/deleteNF${params}`, NFToDelete)
    }

    revalidarNF(NFToReativar){
        return this.post("/revalidarNF", NFToReativar)
    }

    restaurarNFSaida(NFToRestaurar){
        return this.post("/restaurarNFSaida", NFToRestaurar)
    }

    searchImportacaoNFsFalha(){
        return this.get("/searchImportacaoNFsFalha")
    }

    existeFalhaImportacaoNF(){
        return this.get("/existeFalhaImportacaoNF")
    }

    alteraCiencia(obj){
        return this.put("/alteraCiencia", obj)
    }
    
    lancamentoManualNF(notaFiscalDTO){
        return this.post("/lancamentoManualNF", notaFiscalDTO)
    }

    searchDadosDevolucao(notaFiscal){
        let params = `?`
        params = `${params}&idNotaFiscal=${notaFiscal.id}`
        return this.get(`/dadosDevolucao${params}`)
    }
    
    isBonificacaoTotal(notaFiscal){
        let params = `?`
        params = `${params}&idNotaFiscal=${notaFiscal.id}`
        return this.get(`/isBonificacaoTotal${params}`)
    }

    searchIntegracaoApiVendas(){
        return this.get(`/searchIntegracaoApiVendas`)
    }

    syncNFsVenda(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/syncNFsVenda${params}`)
    }

    searchNFsLinkadasPedido(pedidoCompraId){
        let params = `?`
        params = `${params}&pedidoCompraId=${pedidoCompraId}`
        return this.get(`/searchNFsLinkadasPedido${params}`)        
    }

    verificaInformacoesDelecao(nfId){
        let params = `?`
        params = `${params}&id=${nfId}`
        return this.get(`/verificaInformacoesDelecao${params}`)
    }

    buscaDanfe(nfId){
        let params = `?`
        params = `${params}&id=${nfId}`
        return this.getPdf(`/buscaDanfe${params}`)
    }

    buscarPorChaves(chaves){
        return this.post("/buscarPorChaves", chaves)
    }

    geraCadeiaCertificacaoSefaz(){
        return this.get(`/geraCadeiaCertificacaoSefaz`)        
    }

}

export default NFService